<template>
    <StudentAssistant/>
</template>

<script>

import StudentAssistant from '../components/studentAssistant/StudentAssistant.vue'
export default {
  name: 'StudentAssistantView',
  components: {
    StudentAssistant
  },
}
</script>
